import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class DeleteMagiisAccessCarrierProfile
    extends IRequestCommand<
    IDeleteMagiisAccessCarrierProfileRequest,
    ErrorDetails,
    IDeleteMagiisAccessCarrierProfileResponse
    > {
    override _commandType: CommandRequestType = CommandRequestType.DELETE;

    override setParameters(parameters: IDeleteMagiisAccessCarrierProfileRequest) {
        this._commandBody = parameters;
        this.urlSections.push('magiisaccess');
        this.urlSections.push('carrierprofile');
        this.urlSections.push(`${parameters.id}`);
        this.urlSections.push('deleteUserId');
        this.urlSections.push(`${parameters.deleteUserId}`);
        this.composeUrl();
    }
}

export interface IDeleteMagiisAccessCarrierProfileRequest extends ICommandParameters {
    id: number;
    deleteUserId: string;
}

export interface IDeleteMagiisAccessCarrierProfileResponse extends ICommandResponse{

}
